import React from 'react';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const PaymentsPlansScreen: React.FC = () => {
    return (
        <SiteLayout>
            <Header icon='payments' title='Paiements & Plans' />
            <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
                <div className="admin-table-container">
                    <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                        <i className="material-icons" style={{ fontSize: '48px', marginBottom: '10px' }}>payments</i>
                        <p>Module de gestion des paiements et des plans en cours de développement.</p>
                    </div>
                </div>
            </div>
        </SiteLayout>
    );
};

export default PaymentsPlansScreen;
